export const simpleNullFields = [
  'headGarment', 'headStyle', 'headColor', 'questionToDelete',
  'sBodyGarment', 'sBodySleeves', 'sBodyStyle', 'sBodyColor',
  'iBodyGarment', 'iBodyStyle', 'iBodyColor',
  'feetFootwear', 'feetStyle', 'feetColor',
  'hairLength', 'hairType', 'hairColor',
  'gender', 'height', 'volume',
  'headPart', 'headZone', 'headType',
  'bodyPart', 'bodyZone', 'bodyType',
  'armPart', 'armSide', 'armZone', 'armType',
  'legPart', 'legSide', 'legZone', 'legType',
  'accessory', 'part', 'zone',
  'mobility', 'mobilityColor', 'mobilityType',
  'brand', 'weaponElement', 'weaponCaliber', 'weaponColor', 'color'
];
  
export const emptyArrayFields = [
  'headColorMultiSelect', 'sBodyColorMultiSelect', 'iBodyColorMultiSelect',
  'feetColorMultiSelect', 'hairColorMultiSelect', 'headZoneMultiSelect',
  'bodyZoneMultiSelect', 'armZoneMultiSelect', 'legZoneMultiSelect',
  'colorMultiSelect', 'mobilityColorMultiSelect', 'weaponColorMultiSelect',
  'mobilityColorList', 'mobilityTypeList', 'brandList', 'weaponElementList', 'zoneMultiSelect'
];

export const falseFields = [
  'head', 'superiorBody', 'inferiorBody', 'feet',
  'tattooHead', 'tattooBody', 'tattooArm', 'tattooLeg'
];

//mapState
export const listSuffixFields = [
  ...simpleNullFields,
  'stageOfLife',
  'typeBike', 'typeMotorcycle', 'typeCar',
  'brandBike', 'brandMotorcycle', 'brandCar',
  'whiteWeapon', 'fireWeapon', 'objectWeapon',
  'typeOfWeapon'
];

export const advancedComputedFields = [
  // Props de tipo multiSelect 
  { type: 'multiSelect', key: 'headColor', multiKey: 'headColorMultiSelect', phraseKey: 'head' },
  { type: 'multiSelect', key: 'sBodyColor', multiKey: 'sBodyColorMultiSelect', phraseKey: 'sBody' },
  { type: 'multiSelect', key: 'iBodyColor', multiKey: 'iBodyColorMultiSelect', phraseKey: 'iBody' },
  { type: 'multiSelect', key: 'feetColor', multiKey: 'feetColorMultiSelect', phraseKey: 'feet' },
  { type: 'multiSelect', key: 'hairColor', multiKey: 'hairColorMultiSelect', phraseKey: 'hair' },
  { type: 'multiSelect', key: 'mobilityColor', multiKey: 'mobilityColorMultiSelect', phraseKey: 'mobility' },
  { type: 'multiSelect', key: 'weaponColor', multiKey: 'weaponColorMultiSelect', phraseKey: 'weapon' },
  { type: 'multiSelect', key: 'headZone', multiKey: 'headZoneMultiSelect', phraseKey: 'head' },
  { type: 'multiSelect', key: 'bodyZone', multiKey: 'bodyZoneMultiSelect', phraseKey: 'body' },
  { type: 'multiSelect', key: 'armZone', multiKey: 'armZoneMultiSelect', phraseKey: 'arm' },
  { type: 'multiSelect', key: 'legZone', multiKey: 'legZoneMultiSelect', phraseKey: 'leg' },
  { type: 'multiSelect', key: 'color', multiKey: 'colorMultiSelect', phraseKey: 'personalAccessory' },
 
  // Props de tipo object
  { type: 'object', key: 'headGarment', phraseKey: 'head' },
  { type: 'object', key: 'headStyle', phraseKey: 'head' },
  { type: 'object', key: 'sBodyGarment', phraseKey: 'sBody' },
  { type: 'object', key: 'sBodySleeves', phraseKey: 'sBody' },
  { type: 'object', key: 'sBodyStyle', phraseKey: 'sBody' },
  { type: 'object', key: 'iBodyGarment', phraseKey: 'iBody' },
  { type: 'object', key: 'iBodyStyle', phraseKey: 'iBody' },
  { type: 'object', key: 'feetFootwear', phraseKey: 'feet' },
  { type: 'object', key: 'feetStyle', phraseKey: 'feet' },
  { type: 'object', key: 'hairLength', phraseKey: 'hair' },
  { type: 'object', key: 'hairType', phraseKey: 'hair' },
  { type: 'object', key: 'gender', phraseKey: 'texture' },
  { type: 'object', key: 'height', phraseKey: 'texture' },
  { type: 'object', key: 'headPart', phraseKey: 'head' },
  { type: 'object', key: 'headType', phraseKey: 'head' },
  { type: 'object', key: 'bodyPart', phraseKey: 'body' },
  { type: 'object', key: 'bodyType', phraseKey: 'body' },
  { type: 'object', key: 'armPart', phraseKey: 'arm' },
  { type: 'object', key: 'armSide', phraseKey: 'arm' },
  { type: 'object', key: 'armType', phraseKey: 'arm' },
  { type: 'object', key: 'legPart', phraseKey: 'leg' },
  { type: 'object', key: 'legSide', phraseKey: 'leg' },
  { type: 'object', key: 'legType', phraseKey: 'leg' },
  { type: 'object', key: 'accessory', phraseKey: 'personalAccessory' },
  { type: 'object', key: 'part', phraseKey: 'personalAccessory' },
  { type: 'object', key: 'mobilityType', phraseKey: 'mobility' },
  { type: 'object', key: 'brand', phraseKey: 'mobility' },
  { type: 'object', key: 'weaponElement', phraseKey: 'weapon' },
  { type: 'object', key: 'stageOfLife', phraseKey: 'age' }
]
